import script from "./RecursosPortaisModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RecursosPortaisModal.vue?vue&type=script&setup=true&lang=js"

import "./RecursosPortaisModal.vue?vue&type=style&index=0&id=404eb2b7&scoped=true&lang=css"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404eb2b7"]])

export default __exports__